import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import { Subject } from 'rxjs/Subject';


@Injectable()
export class SearchService {

  constructor() { }

  search(terms: Observable<string>) {
    return terms.debounceTime(400)
      .distinctUntilChanged();
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/search/search.service.ts